import { Box, Button, Flex, Modal, Text } from '@homeexchange/design';
import React, { useEffect, useMemo, useState } from 'react';
import { useDevice } from '@homeexchange/shared';
import BillingAddressFields from './form-fields/BillingAddressFields';
import i18n from '../../i18n';
export var EDIT_BILLING_ADDRESS_EVENT = 'edit-billing-address';
var BillingInformationsForm = function (_a) {
    var billingAddress = _a.billingAddress;
    var isMobile = useDevice().isMobile;
    var _b = useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var locale = i18n.language || 'en';
    var regionNames = useMemo(function () { return new Intl.DisplayNames([locale], { type: 'region' }); }, [locale]);
    var onModalChange = function (open) {
        setIsModalOpen(open);
    };
    useEffect(function () {
        var onEventReceived = function () { return setIsModalOpen(true); };
        document.addEventListener(EDIT_BILLING_ADDRESS_EVENT, onEventReceived);
        return function () {
            document.removeEventListener(EDIT_BILLING_ADDRESS_EVENT, onEventReceived);
        };
    }, []);
    return (React.createElement(Flex, { isFullWidth: true, className: "billing-informations" },
        React.createElement(Modal, { isOpen: isModalOpen, onChange: onModalChange, title: i18n.t('subscription:modal_edit_billing_info_title'), isClosable: true, onClose: function () { return setIsModalOpen(false); } },
            React.createElement(BillingAddressFields, { context: "modal", billingAddress: billingAddress, onChange: function () { return setIsModalOpen(false); } })),
        React.createElement(Box, { isFullWidth: true, size: "small", className: "billing-informations-box" },
            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                React.createElement(Flex, { style: !isMobile ? { flex: 1 } : {}, gap: "2", direction: "column" }, billingAddress ? (React.createElement(React.Fragment, null,
                    React.createElement(Text, null, billingAddress.address),
                    React.createElement(Text, null,
                        billingAddress.city,
                        " ",
                        billingAddress.zip_code),
                    React.createElement(Text, null, regionNames.of(billingAddress.iso_country_code) ||
                        billingAddress.iso_country_code))) : (React.createElement(Text, { color: "secondary" }, i18n.t('subscription:billing_info_label_empty_label')))),
                React.createElement("div", null,
                    React.createElement(Button, { hierarchy: "secondary", onClick: function () { return setIsModalOpen(true); } }, i18n.t('subscription:global_edit_information')))))));
};
export default BillingInformationsForm;
